import React from 'react';
import {MenuItem, SelectField} from "material-ui";
import {translate} from "react-i18next";
import i18n from "../../../../../../../../../constants/I18n";

class MenuConfigFormSelectIconSize extends React.Component {
  render() {
    const {t, disabled} = this.props;

    const config = this.props.getFormValue("config");
    const iconSize = config.hasOwnProperty('iconImage') ? (config.iconImage.size || '') : '';

    return (
      <SelectField
        floatingLabelText={t('Wybierz rozmiar ikonki')}
        value={iconSize}
        required
        onChange={(e, index, val) => this.props.onChangeIconImage('size', val)}
        fullWidth
        disabled={disabled}
      >
        <MenuItem value='small' primaryText={`${i18n.t('Mały')} (46x46)`} />
        <MenuItem value='big' primaryText={`${i18n.t('Duży')} (96x96)`} />
      </SelectField>
    );
  }
}

export default translate('translations')(MenuConfigFormSelectIconSize);



// WEBPACK FOOTER //
// ./routes/app/routes/menu/routes/list/components/forms/menu-config/MenuConfigFormSelectIconSize.js